import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';

import {withI18n} from 'spa/Components/Context';

import PricingTable from 'spa/Pages/Pricing/PricingTable';

import {cn} from 'spa/css';

@inject(({store: {tracker}}) =>
  ({tracker}))
@withI18n
class HomePricingSection extends React.Component {
  static propTypes = {
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
    cityName: PropTypes.string.isRequired,
    cityId: PropTypes.string.isRequired,
  };

  render() {
    const {i18n} = this.context;
    const {
      cityName, cityId, trackingCategory, trackingLocation,
    } = this.props;

    return (
      <div className="home-content-section home-pricing-section row">
        <h2
          className={cn(
            'home-content-section__title home-content-section__title--bigger home-content-section__title--centered home-content-section__title--mobile-spaced',
            i18n.lc !== 'en-gb' && 'home-content-section__title--bottom-space',
          )}>{i18n.__react(
            'Pricing in %(cityName)s',
            {
              cityName,
            },
          )}
        </h2>
        <PricingTable
          enablePricingFrom
          trackingCategory={trackingCategory}
          trackingLocation={trackingLocation}
          defaultCity={cityId} />
      </div>
    );
  }
}

export default HomePricingSection;



// WEBPACK FOOTER //
// ./spa/Pages/Home/HomePricingSection.jsx